import { useEffect, useState } from "react";
import "./Header.css";
import HtmlImgae from "../../assets/image/pngegg.png";
import AngulerImage from "../../assets/image/angularjs.png";
import AndroidStudio from "../../assets/image/android-studio.png";
import ShopifyImg from "../../assets/image/icons8-shopify-48.png";
import AmazonImg from "../../assets/image/icons8-amazon-48.png";
import PythonImg from "../../assets/image/icons8-python-48.png";
import RocketImg from "../../assets/image/icons8-rocket-48.png";
import DkImage from "../../assets/image/icons8-digital-marketing-50.png";
import FbImg from "../../assets/image/icons8-fb-48.png";
import LogoImg from "../../assets/image/icons8-logo-50.png";
import ErpImg from "../../assets/image/icons8-erp-50.png";
import AllImg from "../../assets/image/icons8-meter-64.png";
import ContactMailIcon from "@mui/icons-material/ContactMail";
import { Link } from "react-router-dom";
import { Button, Container, Grid, Typography } from "@mui/material";
import logo from "../../assets/image/ZOOdonix-logo.png";
const Header = () => {
  const [isMenuActive, setIsMenuActive] = useState(false);

  const toggleMenu = () => {
    setIsMenuActive(!isMenuActive);
  };

  // const [isAgencyDirectoryOpen, setIsAgencyDirectoryOpen] = useState(false);

  // const toggleAgencyDirectory = () => {
  //   setIsAgencyDirectoryOpen(!isAgencyDirectoryOpen);
  // };

  // State to control the visibility of the menu
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  // Toggle function
  const toggleAgencyDirectory = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  // const [isScrolled, setIsScrolled] = useState(false);

  // Handle scroll event
  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 1) {
        setIsScrolled(true);
      } else {
        setIsScrolled(false);
      }
    };

    // window.addEventListener("scroll", handleScroll);
    // return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const [isScrolled, setIsScrolled] = useState(false);
  const [isSticky, setIsSticky] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 50) {
        setIsScrolled(true);
      } else {
        setIsScrolled(false);
      }

      if (window.scrollY > 100) {
        setIsSticky(true);
      } else {
        setIsSticky(false);
      }
    };

    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);
  return (
    <>
      <header
        style={{
          background: isScrolled
            ? "linear-gradient(to right, #2D0B5A, #C106A3)"
            : "linear-gradient(to right, #2D0B5A, #C106A3)",
          transition: "background 0.8s, backdrop-filter 0.3s",
        }}
        id="site-header"
        className={`header ${isScrolled ? "slide-down" : ""} ${
          isSticky ? "sticky" : "transparent"
        }`}
      >
        <div className="site-width-grid">
          <div
            id="headerMenu"
            className={`header--nav ${isMenuActive ? "is-active" : ""}`}
          >
            <div className="middle-part">
              <div id="site-header-main" className="header--main-nav">
                <div className="logo">
                  <Link to="/">
                    <img
                      src={logo}
                      alt="Zoodonix logo"
                      width="154"
                      height="36"
                    />
                  </Link>
                </div>
                <nav className="header--nav-inner">
                  <ul className="menu">
                    <li className="menu-item">
                      <Link to="/" className="menu-link mobile-main-item">
                        Home
                      </Link>
                    </li>
                    {/* ABOUT US */}
                    <li className="menu-item">
                      <Link to="/about" className="menu-link mobile-main-item">
                        About Us
                      </Link>
                    </li>
                    {/* SERVICES */}
                    <li className="menu-item menu-drop service-drop open">
                      {/* Toggle button */}
                      <span
                        className="menu-link menu-drop--title mobile-main-item mobile-toggler-item"
                        onClick={toggleAgencyDirectory}
                        style={{ cursor: "pointer" }} // Add cursor pointer for better UX
                      >
                        Services
                      </span>

                      {/* Main Content */}
                      <div
                        className="menu-drop--holder agency-drop--holder"
                        id="menuDropdown"
                      >
                        <div className="menu-drop--sub_main agency-drop--main">
                          {/* Large Content */}
                          <div className="menu-drop--sub_category agency-drop--inner desktop-ser-menu active">
                            <Container>
                              <Grid container spacing={0} alignItems="center">
                                <Grid
                                  item
                                  xs={12}
                                  md={12}
                                  sx={{
                                    display: {
                                      xs: "none",
                                      md: "block",
                                      padding: "40px",
                                    },
                                  }}
                                >
                                  <Typography
                                    variant="h6"
                                    gutterBottom
                                    sx={{
                                      marginBottom: "16px",
                                      textTransform: "uppercase",
                                      fontWeight: "bold",
                                    }}
                                  >
                                    Top Website Design & App Development Company
                                    in India
                                  </Typography>

                                  <hr />
                                </Grid>
                                <Grid
                                  container
                                  spacing={2}
                                  sx={{ padding: "0px 40px 0px 40px" }}
                                >
                                  {/* Column 1 */}
                                  <Grid item xs={4} sx={{ textAlign: "start" }}>
                                    <div
                                      style={{
                                        display: "flex",
                                        padding: "0px",
                                      }}
                                    >
                                      <img
                                        src={HtmlImgae}
                                        width={50}
                                        height={50}
                                        alt="Placeholder 1"
                                        style={{ marginRight: "10px" }}
                                      />
                                      <div>
                                        <Link to="/website-design">
                                          <div
                                            style={{
                                              fontSize: "24px",
                                              fontWeight: "bold",
                                            }}
                                          >
                                            Website Design
                                          </div>
                                        </Link>
                                        <p
                                          style={{
                                            fontSize: "15px",
                                            color: "#8d99ae",
                                            marginTop: "1px",
                                          }}
                                        >
                                          Top web design company specialize to
                                          create Robust Website
                                        </p>
                                      </div>
                                    </div>
                                  </Grid>

                                  {/* Column 2 */}
                                  <Grid item xs={4} sx={{ textAlign: "start" }}>
                                    <div
                                      style={{
                                        display: "flex",
                                        padding: "0px",
                                      }}
                                    >
                                      <img
                                        src={AngulerImage}
                                        width={50}
                                        height={50}
                                        alt="Placeholder 1"
                                        style={{ marginRight: "10px" }}
                                      />
                                      <div>
                                        <Link to="/web-development-services">
                                          <div
                                            style={{
                                              fontSize: "24px",
                                              fontWeight: "bold",
                                            }}
                                          >
                                            Web Development
                                          </div>
                                        </Link>
                                        <p
                                          style={{
                                            fontSize: "15px",
                                            color: "#8d99ae",
                                            marginTop: "1px",
                                          }}
                                        >
                                          Top web design company specialize to
                                          create Robust Website
                                        </p>
                                      </div>
                                    </div>
                                  </Grid>

                                  {/* Column 3 */}
                                  <Grid item xs={4} sx={{ textAlign: "start" }}>
                                    <div
                                      style={{
                                        display: "flex",
                                        padding: "0px",
                                      }}
                                    >
                                      <img
                                        src={AndroidStudio}
                                        width={50}
                                        height={50}
                                        alt="Placeholder 1"
                                        style={{ marginRight: "10px" }}
                                      />
                                      <div>
                                        <Link to="/mobile-app-development">
                                          <div
                                            style={{
                                              fontSize: "24px",
                                              fontWeight: "bold",
                                            }}
                                          >
                                            Mobile App Development
                                          </div>
                                        </Link>
                                        <p
                                          style={{
                                            fontSize: "15px",
                                            color: "#8d99ae",
                                            marginTop: "1px",
                                          }}
                                        >
                                          Top web design company specialize to
                                          create Robust Website
                                        </p>
                                      </div>
                                    </div>
                                  </Grid>
                                  <Grid item xs={4} sx={{ textAlign: "start" }}>
                                    <div
                                      style={{
                                        display: "flex",
                                        padding: "0px",
                                      }}
                                    >
                                      <img
                                        src={ShopifyImg}
                                        width={50}
                                        height={50}
                                        alt="Placeholder 1"
                                        style={{ marginRight: "10px" }}
                                      />
                                      <div>
                                        <Link to="/e-commerce-mobile-app-development">
                                          <div
                                            style={{
                                              fontSize: "24px",
                                              fontWeight: "bold",
                                            }}
                                          >
                                            E-Commerce Solution
                                          </div>
                                        </Link>
                                        <p
                                          style={{
                                            fontSize: "15px",
                                            color: "#8d99ae",
                                            marginTop: "1px",
                                          }}
                                        >
                                          Top web design company specialize to
                                          create Robust Website
                                        </p>
                                      </div>
                                    </div>
                                  </Grid>

                                  <Grid item xs={4} sx={{ textAlign: "start" }}>
                                    <div
                                      style={{
                                        display: "flex",
                                        padding: "0px",
                                      }}
                                    >
                                      <img
                                        src={AmazonImg}
                                        width={50}
                                        height={50}
                                        alt="Placeholder 1"
                                        style={{ marginRight: "10px" }}
                                      />
                                      <div>
                                        <Link to="/e-commerce-mobile-app-development">
                                          <div
                                            style={{
                                              fontSize: "24px",
                                              fontWeight: "bold",
                                            }}
                                          >
                                            E-Commerce App Development
                                          </div>
                                        </Link>
                                        <p
                                          style={{
                                            fontSize: "15px",
                                            color: "#8d99ae",
                                            marginTop: "1px",
                                          }}
                                        >
                                          Top web design company specialize to
                                          create Robust Website
                                        </p>
                                      </div>
                                    </div>
                                  </Grid>

                                  <Grid item xs={4} sx={{ textAlign: "start" }}>
                                    <div
                                      style={{
                                        display: "flex",
                                        padding: "0px",
                                      }}
                                    >
                                      <img
                                        src={PythonImg}
                                        width={50}
                                        height={50}
                                        alt="Placeholder 1"
                                        style={{ marginRight: "10px" }}
                                      />
                                      <div>
                                        <Link to="/software-development">
                                          <div
                                            style={{
                                              fontSize: "24px",
                                              fontWeight: "bold",
                                            }}
                                          >
                                            {" "}
                                            Software Development
                                          </div>
                                        </Link>
                                        <p
                                          style={{
                                            fontSize: "15px",
                                            color: "#8d99ae",
                                            marginTop: "1px",
                                          }}
                                        >
                                          Top web design company specialize to
                                          create Robust Website
                                        </p>
                                      </div>
                                    </div>
                                  </Grid>
                                  <Grid item xs={4} sx={{ textAlign: "start" }}>
                                    <div
                                      style={{
                                        display: "flex",
                                        padding: "0px",
                                      }}
                                    >
                                      <img
                                        src={RocketImg}
                                        width={50}
                                        height={50}
                                        alt="Placeholder 1"
                                        style={{ marginRight: "10px" }}
                                      />
                                      <div>
                                        <Link to="/seo-services">
                                          <div
                                            style={{
                                              fontSize: "24px",
                                              fontWeight: "bold",
                                            }}
                                          >
                                            {" "}
                                            Seo Service
                                          </div>
                                        </Link>
                                        <p
                                          style={{
                                            fontSize: "15px",
                                            color: "#8d99ae",
                                            marginTop: "1px",
                                          }}
                                        >
                                          Top web design company specialize to
                                          create Robust Website
                                        </p>
                                      </div>
                                    </div>
                                  </Grid>
                                  <Grid item xs={4} sx={{ textAlign: "start" }}>
                                    <div
                                      style={{
                                        display: "flex",
                                        padding: "0px",
                                      }}
                                    >
                                      <img
                                        src={DkImage}
                                        width={50}
                                        height={50}
                                        alt="Placeholder 1"
                                        style={{ marginRight: "10px" }}
                                      />
                                      <div>
                                        <Link to="/digital-marketing-service">
                                          <div
                                            style={{
                                              fontSize: "24px",
                                              fontWeight: "bold",
                                            }}
                                          >
                                            Digital Marketing
                                          </div>
                                        </Link>
                                        <p
                                          style={{
                                            fontSize: "15px",
                                            color: "#8d99ae",
                                            marginTop: "1px",
                                          }}
                                        >
                                          Top web design company specialize to
                                          create Robust Website
                                        </p>
                                      </div>
                                    </div>
                                  </Grid>
                                  <Grid item xs={4} sx={{ textAlign: "start" }}>
                                    <div
                                      style={{
                                        display: "flex",
                                        padding: "0px",
                                      }}
                                    >
                                      <img
                                        src={FbImg}
                                        width={50}
                                        height={50}
                                        alt="Placeholder 1"
                                        style={{ marginRight: "10px" }}
                                      />
                                      <div>
                                        <Link to="/digital-marketing-service">
                                          <div
                                            style={{
                                              fontSize: "24px",
                                              fontWeight: "bold",
                                            }}
                                          >
                                            Social Media Marketing
                                          </div>
                                        </Link>
                                        <p
                                          style={{
                                            fontSize: "15px",
                                            color: "#8d99ae",
                                            marginTop: "1px",
                                          }}
                                        >
                                          Top web design company specialize to
                                          create Robust Website
                                        </p>
                                      </div>
                                    </div>
                                  </Grid>
                                  <Grid item xs={4} sx={{ textAlign: "start" }}>
                                    <div
                                      style={{
                                        display: "flex",
                                        padding: "0px",
                                      }}
                                    >
                                      <img
                                        src={LogoImg}
                                        width={50}
                                        height={50}
                                        alt="Placeholder 1"
                                        style={{ marginRight: "10px" }}
                                      />
                                      <div>
                                        <Link to="/logo-design-service">
                                          <div
                                            style={{
                                              fontSize: "24px",
                                              fontWeight: "bold",
                                            }}
                                          >
                                            Logo Design
                                          </div>
                                        </Link>
                                        <p
                                          style={{
                                            fontSize: "15px",
                                            color: "#8d99ae",
                                            marginTop: "1px",
                                          }}
                                        >
                                          Top web design company specialize to
                                          create Robust Website
                                        </p>
                                      </div>
                                    </div>
                                  </Grid>
                                  <Grid item xs={4} sx={{ textAlign: "start" }}>
                                    <div
                                      style={{
                                        display: "flex",
                                        padding: "0px",
                                      }}
                                    >
                                      <img
                                        src={ErpImg}
                                        width={50}
                                        height={50}
                                        alt="Placeholder 1"
                                        style={{ marginRight: "10px" }}
                                      />
                                      <div>
                                        <Link to="/erp-services">
                                          <div
                                            style={{
                                              fontSize: "24px",
                                              fontWeight: "bold",
                                            }}
                                          >
                                            ERP Servicces
                                          </div>
                                        </Link>
                                        <p
                                          style={{
                                            fontSize: "15px",
                                            color: "#8d99ae",
                                            marginTop: "1px",
                                          }}
                                        >
                                          Top web design company specialize to
                                          create Robust Website
                                        </p>
                                      </div>
                                    </div>
                                  </Grid>
                                  <Grid item xs={4} sx={{ textAlign: "start" }}>
                                    <div
                                      style={{
                                        display: "flex",
                                        padding: "0px",
                                      }}
                                    >
                                      <img
                                        src={AllImg}
                                        width={50}
                                        height={50}
                                        alt="Placeholder 1"
                                        style={{ marginRight: "10px" }}
                                      />
                                      <div>
                                        <div
                                          style={{
                                            fontSize: "24px",
                                            fontWeight: "bold",
                                          }}
                                        >
                                          Website Design
                                        </div>
                                        <p
                                          style={{
                                            fontSize: "15px",
                                            color: "#8d99ae",
                                            marginTop: "1px",
                                          }}
                                        >
                                          Top web design company specialize to
                                          create Robust Website
                                        </p>
                                      </div>
                                    </div>
                                  </Grid>
                                </Grid>
                              </Grid>
                            </Container>
                            <div style={{ background: "#7209b7" }}>
                              <Container>
                                <div
                                  style={{
                                    padding: "5px",
                                    color: "#fff",
                                    display: "flex",
                                    alignItems: "center",
                                  }}
                                >
                                  <div>
                                    <img src={logo} width={150} />
                                  </div>
                                  <p
                                    style={{
                                      fontSize: "20px",
                                      marginLeft: "10px",
                                    }}
                                  >
                                    {" "}
                                    100% off Domain and Hosting for 1 Yaer
                                  </p>
                                </div>
                              </Container>
                            </div>
                          </div>
                        </div>

                        {/* Toggling Submenu */}
                        <div
                          className={`menu-drop--sub_main agency-drop--main mobile-submenu ${
                            isMenuOpen ? "active" : ""
                          }`}
                        >
                          <div className="menu-drop--sub_category agency-drop--inner">
                            <ul className="menu-drop--sub_category-list">
                              <li>
                                <Link to="/website-design">
                                  <i className="icon"></i> Website Design
                                </Link>
                              </li>
                              <li>
                                <Link to="/web-development-services">
                                  <i className="icon"></i> Web Development
                                  Services
                                </Link>
                              </li>
                              <li>
                                <Link to="/mobile-app-development">
                                  <i className="icon"></i> Mobile App
                                  Development
                                </Link>
                              </li>
                              <li>
                                <Link to="/e-commerce-mobile-app-development">
                                  <i className="icon"></i> E-Commerce Solution
                                </Link>
                              </li>
                              <li>
                                <Link to="/e-commerce-mobile-app-development">
                                  <i className="icon"></i> E-Commerce App
                                  Development
                                </Link>
                              </li>
                              <li>
                                <Link to="/e-commerce-mobile-app-development">
                                  <i className="icon"></i> E-Commerce App
                                  Development
                                </Link>
                              </li>
                            </ul>
                          </div>
                        </div>
                      </div>
                    </li>

                    <li className="menu-item">
                      <a
                        href="#portfolio"
                        className="menu-link mobile-main-item"
                        onClick={(e) => {
                          e.preventDefault();
                          const portfolioSection =
                            document.getElementById("portfolio");
                          if (portfolioSection) {
                            portfolioSection.scrollIntoView({
                              behavior: "smooth",
                            });
                          } else {
                            // Redirect to home page and scroll to portfolio
                            window.location.href = "/#portfolio";
                          }
                        }}
                      >
                        Portfolio
                      </a>
                    </li>

                    {/* ABOUT US */}
                    <li className="menu-item">
                    <a
                        href="#testimonials"
                        className="menu-link mobile-main-item"
                        onClick={(e) => {
                          e.preventDefault();
                          const portfolioSection =
                            document.getElementById("testimonials");
                          if (portfolioSection) {
                            portfolioSection.scrollIntoView({
                              behavior: "smooth",
                            });
                          } else {
                            // Redirect to home page and scroll to portfolio
                            window.location.href = "/#testimonials";
                          }
                        }}
                      >
                        Testimonials
                      </a>
                    </li>

                    {/* FAQ */}
                    <li className="menu-item">
                    <a
                        href="#faq"
                        className="menu-link mobile-main-item"
                        onClick={(e) => {
                          e.preventDefault();
                          const portfolioSection =
                            document.getElementById("faq");
                          if (portfolioSection) {
                            portfolioSection.scrollIntoView({
                              behavior: "smooth",
                            });
                          } else {
                            // Redirect to home page and scroll to portfolio
                            window.location.href = "/#faq";
                          }
                        }}
                      >
                        FAQ
                      </a>
                    </li>

                    {/* Blog */}
                    <li className="menu-item">
                      <Link to="/contact" className="menu-link mobile-main-item">
                      Contact
                      </Link>
                    </li>

                    {/* AGENCY DIRECTORY */}
                    {/* <li className="menu-item menu-drop agency-drop">
                      <span className="menu-link menu-drop--title mobile-main-item mobile-toggler-item">
                        AGENCY DIRECTORY
                      </span>
                      <div className="menu-drop--holder agency-drop--holder">
                        <div className="menu-drop--sub_nav">
                          <div className="menu-drop--sub_nav-item active">
                            demo
                          </div>
                        </div>
                        <div className="menu-drop--sub_main agency-drop--main">
                          <div className="menu-drop--sub_category agency-drop--inner active">
                            <ul className="menu-drop--sub_category-list">
                              <li>
                                <a href="#">
                                  <i className="icon"></i> Digital Agencies
                                </a>
                              </li>
                            </ul>
                          </div>
                        </div>
                      </div>
                    </li> */}

                    {/* DESIGN AWARDS */}
                    {/* <li className="menu-item menu-drop inspiration-drop">
                      <a
                        href="#"
                        className="menu-link mobile-main-item menu-drop--title"
                      >
                        Design Awards
                      </a>
                    </li> */}
                  </ul>

                  {/* CTA Section */}
                  <div className="cta">
                    <Button
                      variant="outlined"
                      style={{
                        color: "black",
                        borderRadius: "40px",
                        padding: "10px 40px",
                        border: 0,
                        background:'#ffb703'
                        // background:
                        //   "linear-gradient(-89deg, #E6735E, #F25F36 28%, #DB1A88 82%, #FF0091)",
                      }}
                    >
                      <ContactMailIcon
                        style={{ marginRight: "5px", fontSize: "20px" }}
                      />
                      <span style={{ fontWeight: "bold" }}>Contact Us</span>
                    </Button>
                  </div>
                </nav>
              </div>
              <div className="header--side-nav">
                <div className="user">
                  <div className="user-login">
                    <a href="#" aria-label="Login" className="user-login--icon">
                      <svg width="11" height="12" className="icon">
                        <use xlinkHref="#icon-no-auth"></use>
                      </svg>
                    </a>
                  </div>
                </div>
                <div className="burger-holder">
                  <button
                    id="burger"
                    type="button"
                    aria-label="Burger Navigation"
                    className={`burger ${isMenuActive ? "is-active" : ""}`}
                    onClick={toggleMenu}
                  >
                    <span></span>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </header>
    </>
  );
};

export default Header;
